import type { ComponentPropsWithoutRef } from 'react'

export type ArticleH2Props = ComponentPropsWithoutRef<'h2'>

const ARTICLE_H2_CLASS =
  '[font-size:24px] [line-height:var(--font-heading-lg-line)] min-[768px]:[font-size:30px] min-[768px]:[line-height:36px] [font-weight:var(--font-heading-lg-weight)] [color:var(--color-text-primary)]'

export const ArticleH2 = ({ className, children, ...props }: ArticleH2Props) => (
  <h2 {...props} className={`${ARTICLE_H2_CLASS} ${className ?? ''}`}>
    {children}
  </h2>
)
